<template>
  <BgImageLayout title="Recent actions">
    <AgGridWrapper
      :options="gridOptions"
      :infinite-scroll-request="infiniteScrollRequest"
      :update-rows-count="updateRowsCount"
      :include-search-box="true"
      store-namespace="recentActions"
    >
      <template #footerActions>
        <div class="row fit q-pr-md q-pb-md justify-end">Total Rows: {{ totalRows }}</div>
      </template>
    </AgGridWrapper>
  </BgImageLayout>
</template>

<script>
import * as apiTo from './api'
import { dateSorter, getProp } from '@/lib/generic.utils'
// Libraries
import moment from 'moment'
// Components
import AgGridWrapper from '@components/ag-grid-helpers/AgGridWrapper'

export default {
  name: 'LmPageRecentActions',

  components: {
    AgGridWrapper
  },

  data: () => ({
    totalRows: null
  }),

  computed: {
    gridOptions() {
      moment.relativeTimeThreshold('ss', 59)
      moment.relativeTimeThreshold('s', 59)
      moment.relativeTimeThreshold('m', 59)
      moment.relativeTimeThreshold('h', 23)
      moment.relativeTimeThreshold('d', 27)
      moment.relativeTimeThreshold('M', 11)

      function cellMessage(params) {
        const description = params.data.description
        const properties = params.data.properties

        if (description === 'Created') return 'Record has been created'
        if (!Array.isArray(properties)) return properties.replace('.', ' ')

        const wereOrWas = properties.length > 1 ? 'were' : 'was'
        const columnOrColumns = properties.length > 1 ? 'columns' : 'column'

        const formatter = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' })

        return `${formatter.format(properties)} ${columnOrColumns} ${wereOrWas} updated`
      }

      return {
        columnDefs: [
          {
            headerName: this.getTranslation('recent_actions.index.columns.description') || 'Description',
            field: 'description',
            tooltipField: 'description'
          },
          {
            headerName: 'Entity',
            field: 'subject_type'
          },
          {
            headerName: 'Properties',
            cellRenderer: cellMessage,
            tooltipValueGetter: cellMessage
          },
          {
            headerName: this.getTranslation('recent_actions.index.columns.user') || 'User',
            field: 'causer',
            cellRenderer: params => getProp(params.value, 'name'),
            tooltipValueGetter: params => getProp(params.value, 'name')
          },
          {
            headerName: this.getTranslation('shared.on_date') || 'Created on',
            field: 'created_at',
            comparator: dateSorter,
            cellRenderer: params => this.durationInfo(params.value),
            tooltipValueGetter: params => this.durationInfo(params.value)
          }
        ],
        defaultColDef: {
          suppressMenu: true
        },
        context: {
          sortColumn: 4,
          sortOrder: 'desc'
        },
        cacheBlockSize: 40,
        pagination: false,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        domLayout: 'normal'
      }
    }
  },
  methods: {
    infiniteScrollRequest(request) {
      return apiTo.getRecentActions(request)
    },

    updateRowsCount(rowsCount) {
      this.totalRows = rowsCount
    },

    durationInfo(date) {
      // to render time correctly, date must be converted to UTC
      let incident = moment.utc(date, 'YYYY-MM-DD hh:mm:ss')
      return moment(incident).fromNow()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/mixins'

>>> .table-content {
  height calc(100vh - 180px) !important
}

>>> .ag-theme-material {
  height calc(100%)
}

>>> .ag-floating-top {
  overflow-y auto !important
}

styledScrollFor('>>> .ag-body-viewport.ag-layout-normal');
</style>
